import Api from './Api';

export default{
    create(data){
        return Api.post('/auth/propertyCategory', data)
    },
    read(){
        return Api.get('/propertyCategory')
    },
    update(id, data){
        return Api.put(`/auth/propertyCategory/${id}`, data)
    },
    delete(id){
        return Api.delete(`/auth/propertyCategory/${id}`)
    }
}